import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// Need to end up moving outside, using system env.
const firebaseConfig = {
    apiKey: "AIzaSyAYGRpRxlGZYyhjjTXmSYxF2Ylsi2bq67Y",
    authDomain: "yoruba-dictionary-5cdea.firebaseapp.com",
    projectId: "yoruba-dictionary-5cdea",
    storageBucket: "yoruba-dictionary-5cdea.firebasestorage.app",
    messagingSenderId: "1014244720237",
    appId: "1:1014244720237:web:f6a3149af143fe40d50964",
    measurementId: "G-HMYWVDFB6P"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { db };